const isProd = process.env.NODE_ENV === 'production';
export const environment = {
    Debug: !isProd,
    Verbose: !isProd,
    Development: !isProd,
    Region: 'CN',
    NoRedirect: true,
};
